/** App JWT used for microservice Authorization headers. */
export const ACCESS_TOKEN_KEY = 'mlct';

/** Refresh token used to obtain a new App JWT pair. */
export const REFRESH_TOKEN_KEY = 'mlrt';

/** One hour without user interaction before automatic logout. */
export const INACTIVITY_TIMEOUT_MS = 3_600_000;

/** Profile Management auth endpoints that must not trigger token refresh on 401. */
export const AUTH_EXCHANGE_PATH = '/api/v1/auth/exchange';
export const AUTH_REFRESH_PATH = '/api/v1/auth/refresh';
export const AUTH_PAGE_ACCESS_PATH = '/api/v1/auth/page-access';

export const LEGACY_OWNED_LOCAL_STORAGE_KEYS = [
  ACCESS_TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  'lastActivity',
  'userId',
  'profile'
] as const;

export function clearLegacyOwnedLocalStorage(): void {
  LEGACY_OWNED_LOCAL_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
}
